module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("6DCs1"))).then(() => parcelRequire('eKAjN'));